import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import './style.scss';

/**
 * EndNode:
 *  - A Row Component that render the Output Nodes of
 *    DesignSlide Second.
 */
export function EndRow(props) {
  const renderEndNodes = (node) => (
    <Image key={node.id} src={node.image} alt={node.image} />
  );

  if (props.current) {
    return (
      <div className='endRow'>{props.nodeComponents.map(renderEndNodes)}</div>
    );
  } else return null;
}

EndRow.propTypes = {
  /**
   * Boolean specifying if node should be displayed
   */
  current: PropTypes.bool.isRequired,
  /**
   * List of NodeComponents to be displayed in EndRow
   * Usually a Single Image is to be displayed.
   */
  nodeComponents: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
    })
  ).isRequired,
  /**
   * Unique Id for the EndRow Node
   */
  nodeId: PropTypes.number,
};

EndRow.defaultProps = {
  current: false,
};
